import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]


export default /*@__PURE__*/_defineComponent({
  __name: 'KakaoLoginButton',
  props: {
    label: { default: '카카오로 로그인' },
    busy: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "kakao-login-btn",
    disabled: __props.disabled || __props.busy,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("span", {
      class: "kakao-login-btn__icon",
      "aria-hidden": "true"
    }, [
      _createElementVNode("svg", {
        viewBox: "0 0 24 24",
        width: "18",
        height: "18"
      }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M12 4C7.58 4 4 6.86 4 10.4c0 2.27 1.52 4.26 3.8 5.4l-.97 3.56c-.06.22.18.4.37.28l4.26-2.82c.18.01.35.02.54.02 4.42 0 8-2.86 8-6.44C20 6.86 16.42 4 12 4z"
        })
      ])
    ], -1)),
    _createElementVNode("span", null, _toDisplayString(__props.busy ? '카카오 연결 중...' : __props.label), 1)
  ], 8, _hoisted_1))
}
}

})